import { useMemo } from 'react';
import type { ProductTourHost } from '@terra/ui-product-tour';
import { useProxyStore } from '../store/proxy-store';
import { useMainContentTabs, useSidebarState } from '../store/layoutStore';
import { sidebarTabMapping } from '../components/layout/utils';
import { hasVaultRegistrationInRequests } from '../product-tours/booth-vault-registration';

export function useBoothTourHost(): {
  host: ProductTourHost;
  conditionSnapshot: Record<string, boolean>;
} {
  const isProxyRunning = useProxyStore((state) => state.isProxyRunning);
  const vaultRegistered = useProxyStore((state) =>
    hasVaultRegistrationInRequests(state.requests),
  );

  const { setSidebarTab } = useSidebarState();
  const { navigateInActiveTab } = useMainContentTabs();

  const host = useMemo((): ProductTourHost => {
    return {
      checkCondition: (conditionId) => {
        if (conditionId === 'proxy-running') {
          return isProxyRunning;
        }
        if (conditionId === 'vault-registered') {
          return vaultRegistered;
        }
        return false;
      },
      runEnterEffect: (effectId) => {
        if (effectId === 'sidebar:requests') {
          setSidebarTab('requests');
          navigateInActiveTab(sidebarTabMapping.requests);
          return;
        }
        if (effectId === 'sidebar:signals') {
          setSidebarTab('signals');
          navigateInActiveTab(sidebarTabMapping.signals);
        }
      },
    };
  }, [isProxyRunning, navigateInActiveTab, setSidebarTab, vaultRegistered]);

  return {
    host,
    conditionSnapshot: {
      'proxy-running': isProxyRunning,
      'vault-registered': vaultRegistered,
    },
  };
}
